import React from 'react';
import { HeaderPrimaryButton } from './buttons/HeaderPrimaryButton';
import style from './AccountNotificationButton.module.scss';
import { addUtmParam } from '../addUtmParam';
import { useAperzaUserContext } from './AperzaUserContext';
export function HeaderCompanyGuideButton() {
    const { serviceType } = useAperzaUserContext();
    return (React.createElement(HeaderPrimaryButton, { outlined: true, buttonClassName: style.notificationLoginButton, href: addUtmParam(`https://www.aperza.co.jp/contact/contact-plan`, 'header', serviceType) },
        React.createElement("span", null,
            "\u30A2\u30DA\u30EB\u30B6\u306B\u63B2\u8F09\u3092",
            React.createElement("br", null),
            "\u304A\u8003\u3048\u306E\u4F01\u696D\u306F\u3053\u3061\u3089")));
}
